<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-350 transition-colors relative">
  <!-- Title & Refresh Action Controls -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
    <div>
      <h1 class="text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">รายการรับชำระ (Parking Finance)
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        จัดการและตรวจสอบรายการชำระค่าธรรมเนียมจอดรถทั้งหมดในระบบ</p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3">
      <button (click)="toggleDashboard()"
        class="hidden sm:flex px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2 cursor-pointer font-bold"
        [title]="showDashboard ? 'ซ่อนแดชบอร์ด' : 'แสดงแดชบอร์ด'">
        <span class="material-icons text-lg">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
        <span class="text-sm">{{ showDashboard ? 'ซ่อนแดชบอร์ด' : 'แสดงแดชบอร์ด' }}</span>
      </button>

      <div
        class="flex items-center gap-2 px-3 py-2 bg-white/95 dark:bg-slate-800/95 rounded-xl border border-slate-100/50 dark:border-slate-700 shadow-sm h-[46px] w-full sm:w-auto focus-within:ring-2 focus-within:ring-amber-300 transition-all">
        <span class="material-icons text-slate-400 text-xl flex-shrink-0">calendar_today</span>
        <mat-date-range-input [rangePicker]="headerPicker"
          class="text-xs font-bold text-slate-650 dark:text-slate-300 w-full min-w-[180px] sm:min-w-[220px]">
          <input matStartDate [(ngModel)]="startDate" (dateChange)="onDateChange()" placeholder="เริ่มต้น">
          <input matEndDate [(ngModel)]="endDate" (dateChange)="onDateChange()" placeholder="สิ้นสุด">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="headerPicker"
          class="text-slate-400 hover:text-amber-500 cursor-pointer"></mat-datepicker-toggle>
        <mat-date-range-picker #headerPicker panelClass="modern-yellow-datepicker"></mat-date-range-picker>
      </div>

      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
        <span
          class="text-[11px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-wider leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-650 dark:text-slate-350 leading-none">{{ lastFetchedTime |
          date:'HH:mm:ss' }}</span>
      </div>

      <button (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-800/95 text-slate-550 dark:text-slate-400 rounded-xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center cursor-pointer"
        title="รีเฟรช">
        <span class="material-icons text-xl">refresh</span>
      </button>
    </div>
  </div>

  <!-- Collapsible Marketing Dashboard Section -->
  <div class="overflow-hidden transition-all duration-550 ease-in-out"
    [style.max-height]="showDashboard ? '700px' : '0'" [style.opacity]="showDashboard ? '1' : '0'"
    [style.margin-bottom]="showDashboard ? '2.5rem' : '0'">

    <!-- KPI Stats Grid (4 columns) -->
    <div *ngIf="dashboardStats.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div *ngFor="let stat of dashboardStats; let i = index"
        class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] p-6 shadow-[0_20px_50px_rgba(0,0,0,0.03)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.2)] border border-slate-100/50 dark:border-slate-700/50 hover:shadow-[0_20px_50px_rgba(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group">

        <!-- Animated Background Decor Blob -->
        <div
          class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.06] dark:opacity-[0.12] transition-transform duration-500 group-hover:scale-110"
          [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

        <div class="relative z-10 flex justify-between items-start mb-4">
          <div
            class="w-12 h-12 rounded-2xl flex items-center justify-center shadow-sm transition-transform duration-300 group-hover:scale-105"
            [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
            <span class="material-icons text-2xl">{{ stat.icon }}</span>
          </div>
        </div>

        <div class="relative z-10">
          <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">{{ stat.title
            }}</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ stat.value }}</div>
          <p class="text-xs text-slate-400 mt-1">{{ stat.subtitle }}</p>
        </div>
      </div>
    </div>

    <!-- Ratio & Activity (chart section disabled) -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <!-- Main Chart Section — disabled
      <div
        class="animate-fade-in lg:col-span-2 bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.03)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.25)] border border-slate-100/50 dark:border-slate-700/50 pt-8 pb-12 px-8 relative overflow-visible z-10">
        ...
      </div>
      -->

      <!-- Status Ratio -->
      <div
          class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.03)] border border-slate-100/50 dark:border-slate-700/50 p-6 flex flex-col justify-between">
          <h3 class="text-sm font-black text-slate-850 dark:text-slate-100 mb-4 tracking-tight">สัดส่วนสถานะการรับชำระ
          </h3>
          <div class="flex items-center justify-center gap-6 py-2">
            <div class="relative w-28 h-28 flex-shrink-0">
              <svg viewBox="0 0 36 36" class="w-full h-full transform -rotate-90">
                <path class="text-slate-100 dark:text-slate-700" stroke-dasharray="100, 100"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                <path class="text-amber-500 transition-all duration-1000 ease-out"
                  [attr.stroke-dasharray]="normalPercent + ', 100'"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" />
              </svg>
              <div class="absolute inset-0 flex flex-col items-center justify-center">
                <span class="text-2xl font-black text-slate-800 dark:text-slate-100 leading-none">{{ normalPercent
                  }}%</span>
                <span class="text-[9px] font-bold text-amber-500 uppercase tracking-widest mt-1">ปกติ</span>
              </div>
            </div>
            <div class="flex flex-col gap-2.5">
              <div class="flex items-center gap-2">
                <div class="w-3.5 h-3.5 rounded-full bg-amber-500 shadow-sm shadow-amber-500/20"></div>
                <div class="flex flex-col">
                  <span class="text-[9px] font-bold text-slate-400 tracking-wider">สถานะปกติ</span>
                  <span class="text-sm font-extrabold text-slate-750 dark:text-slate-200 leading-none">{{ normalPercent
                    }}%</span>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <div class="w-3.5 h-3.5 rounded-full bg-rose-500 shadow-sm shadow-rose-500/20"></div>
                <div class="flex flex-col">
                  <span class="text-[9px] font-bold text-slate-400 tracking-wider">สถานะยกเลิก</span>
                  <span class="text-sm font-extrabold text-slate-750 dark:text-slate-200 leading-none">{{
                    cancelledPercent }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      <!-- Recent Activity -->
      <div
          class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.03)] border border-slate-100/50 dark:border-slate-700/50 p-6 flex flex-col">
          <h3 class="text-sm font-black text-slate-850 dark:text-slate-100 mb-5">รับชำระล่าสุด</h3>
          <div class="relative pl-3 flex-1">
            <div class="absolute left-7 top-3 bottom-3 w-0.5 bg-slate-100 dark:bg-slate-700"></div>
            <div class="space-y-5 relative">
              <div *ngFor="let item of recentActivity" class="flex items-start gap-4 group">
                <div
                  class="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-amber-600 dark:text-amber-400 text-xs font-bold shadow-sm ring-4 ring-white dark:ring-slate-800 z-10 bg-amber-100 dark:bg-amber-500/20 transition-transform duration-300 group-hover:scale-110">
                  PF
                </div>
                <div class="flex-1 pt-0.5">
                  <div class="flex justify-between items-start">
                    <h5
                      class="text-xs font-bold text-slate-850 dark:text-slate-200 group-hover:text-amber-500 transition-colors">
                      {{ item.receiptId }}
                    </h5>
                    <span
                      class="text-[9px] font-bold text-slate-450 dark:text-slate-400 bg-slate-50 dark:bg-slate-700 px-1.5 py-0.5 rounded-full border border-slate-100/50 dark:border-slate-600 whitespace-nowrap">
                      {{ getTimeAgo(item.paidDate) }}
                    </span>
                  </div>
                  <p class="text-[10px] text-slate-500 mt-0.5">{{ item.feeName }} • {{ item.feeTypeName }} • <b>{{
                      item.total | number }} ฿</b></p>
                </div>
              </div>
              <div *ngIf="recentActivity.length === 0" class="text-center text-slate-400 py-6">
                <span class="material-icons text-2xl mb-1 opacity-40">history</span>
                <p class="text-xs">ไม่มีรายการชำระเงินล่าสุด</p>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>

  <!-- Table Container card -->
  <div
    class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.03)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden"
    style="animation-delay: 0.1s;">

    <!-- Control Bar (Search, Filters toggle) -->
    <div class="p-6 border-b border-slate-100 dark:border-slate-750 flex flex-col gap-4 relative z-30">
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <h3 class="text-base font-extrabold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500 text-xl">payments</span>
          รายการรับชำระทั้งหมด
        </h3>

        <div class="flex items-center gap-3">
          <button (click)="toggleTableFilters()"
            class="flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold transition-all shadow-sm border cursor-pointer"
            [ngClass]="showTableFilters ? 'bg-amber-50 dark:bg-amber-550/10 text-amber-600 dark:text-amber-400 border-amber-200 dark:border-amber-500/30' : 'bg-white dark:bg-slate-800 text-slate-500 hover:text-amber-500 border-slate-200/80 dark:border-slate-700 hover:border-amber-300'">
            <span class="material-icons text-[16px]">{{ showTableFilters ? 'filter_list_off' : 'filter_list' }}</span>
            <span>ตัวกรองขั้นสูง</span>
          </button>
        </div>
      </div>

      <!-- Advanced Filter Panel (Collapsible Horizontal) -->
      <div *ngIf="showTableFilters"
        class="animate-fade-in grid grid-cols-1 md:grid-cols-4 gap-4 pt-3 border-t border-dashed border-slate-100 dark:border-slate-700">

        <!-- Search input group -->
        <div class="flex flex-col gap-1.5">
          <label
            class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">ค้นหาด่วน</label>
          <div
            class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200/60 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-850 focus-within:ring-2 focus-within:ring-amber-300 rounded-xl overflow-visible relative">
            <div class="relative min-w-[100px] border-r border-slate-200/60 dark:border-slate-700">
              <button (click)="toggleSearchTypeDropdown()"
                class="w-full pl-3 pr-2 py-2 text-xs font-bold text-slate-650 dark:text-slate-350 flex items-center justify-between hover:text-amber-500 cursor-pointer">
                <span>{{ currentSearchTypeLabel }}</span>
                <span class="material-icons text-slate-400 text-xs transition-transform duration-200"
                  [class.rotate-180]="isSearchTypeDropdownOpen">expand_more</span>
              </button>

              <div *ngIf="isSearchTypeDropdownOpen" (mousedown)="$event.preventDefault()"
                class="absolute top-full mt-1.5 left-0 w-[140px] bg-white dark:bg-slate-800 border border-slate-100/60 dark:border-slate-750 shadow-xl rounded-xl py-1 z-50 animation-fade-in-up">
                <button (click)="selectSearchType('all')"
                  class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 hover:text-amber-500 block transition-colors cursor-pointer">ทั้งหมด</button>
                <button (click)="selectSearchType('receiptid')"
                  class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 hover:text-amber-500 block transition-colors cursor-pointer">เลขใบเสร็จ</button>
                <button (click)="selectSearchType('feename')"
                  class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 hover:text-amber-500 block transition-colors cursor-pointer">ชื่อ
                  Fee</button>
                <button (click)="selectSearchType('feetypename')"
                  class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 hover:text-amber-500 block transition-colors cursor-pointer">ประเภทชำระ</button>
                <button (click)="selectSearchType('sitename')"
                  class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 hover:text-amber-500 block transition-colors cursor-pointer">ชื่อ
                  Site</button>
                <button (click)="selectSearchType('status')"
                  class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 hover:text-amber-500 block transition-colors cursor-pointer">สถานะ</button>
              </div>
            </div>

            <div class="relative flex-1">
              <span
                class="absolute left-2.5 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-base">search</span>
              <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" placeholder="คำค้นหา..."
                class="w-full pl-8 pr-3 py-2 bg-transparent border-none text-xs text-slate-650 dark:text-slate-300 outline-none focus:ring-0">
            </div>
          </div>
        </div>

        <!-- Autocomplete Combo box: Fee Type -->
        <div class="flex flex-col gap-1.5">
          <label
            class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">ประเภทชำระเงิน</label>
          <div class="relative w-full">
            <div
              class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200/60 dark:border-slate-700 rounded-xl px-3.5 py-1 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-300">
              <input type="text" [(ngModel)]="searchFeeTypeText" (focus)="isFeeTypeDropdownOpen = true"
                (blur)="closeFeeTypeDropdown()" placeholder="พิมพ์ค้นหา..."
                class="w-full bg-transparent border-none text-xs font-bold text-slate-650 dark:text-slate-300 focus:ring-0 p-0 outline-none">
              <span class="material-icons text-slate-400 text-sm">expand_more</span>
            </div>

            <!-- Absolute fake dropdown menu -->
            <div *ngIf="isFeeTypeDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute top-full mt-1.5 left-0 w-full bg-white dark:bg-slate-800 border border-slate-100/60 dark:border-slate-750 shadow-xl rounded-xl py-1 z-50 max-h-48 overflow-y-auto custom-scrollbar">
              <button (click)="selectFeeType('')"
                class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-500 hover:bg-slate-50 block hover:text-amber-500 transition-colors cursor-pointer">ทั้งหมด</button>
              <button *ngFor="let opt of filteredFeeTypeOptions" (click)="selectFeeType(opt)"
                class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-650 dark:text-slate-300 hover:bg-slate-50 block hover:text-amber-500 transition-colors cursor-pointer">
                {{ opt }}
              </button>
            </div>
          </div>
        </div>

        <!-- Autocomplete Combo box: Fee Name -->
        <div class="flex flex-col gap-1.5">
          <label class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">ชื่อ Fee /
            บริการ</label>
          <div class="relative w-full">
            <div
              class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200/60 dark:border-slate-700 rounded-xl px-3.5 py-1 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-300">
              <input type="text" [(ngModel)]="searchFeeNameText" (focus)="isFeeNameDropdownOpen = true"
                (blur)="closeFeeNameDropdown()" placeholder="พิมพ์ค้นหา..."
                class="w-full bg-transparent border-none text-xs font-bold text-slate-650 dark:text-slate-300 focus:ring-0 p-0 outline-none">
              <span class="material-icons text-slate-400 text-sm">expand_more</span>
            </div>

            <div *ngIf="isFeeNameDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute top-full mt-1.5 left-0 w-full bg-white dark:bg-slate-800 border border-slate-100/60 dark:border-slate-750 shadow-xl rounded-xl py-1 z-50 max-h-48 overflow-y-auto custom-scrollbar">
              <button (click)="selectFeeName('')"
                class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-500 hover:bg-slate-50 block hover:text-amber-500 transition-colors cursor-pointer">ทั้งหมด</button>
              <button *ngFor="let opt of filteredFeeNameOptions" (click)="selectFeeName(opt)"
                class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-650 dark:text-slate-300 hover:bg-slate-50 block hover:text-amber-500 transition-colors cursor-pointer">
                {{ opt }}
              </button>
            </div>
          </div>
        </div>

        <!-- Additional input parameter: minTotal -->
        <div class="flex flex-col gap-1.5 md:col-start-1">
          <label class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">ยอดรวมขั้นต่ำ
            (฿)</label>
          <input type="number" [(ngModel)]="minTotal" (ngModelChange)="onSearchChange()" placeholder="ระบุมูลค่า..."
            class="px-3.5 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200/60 dark:border-slate-700 focus:bg-white focus:ring-2 focus:ring-amber-300 rounded-xl text-xs font-bold text-slate-650 dark:text-slate-300 outline-none">
        </div>

        <!-- Autocomplete Combo box: Status -->
        <div class="flex flex-col gap-1.5">
          <label
            class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">สถานะรายการ</label>
          <div class="relative w-full">
            <div
              class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200/60 dark:border-slate-700 rounded-xl px-3.5 py-1 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-300">
              <input type="text" [(ngModel)]="searchStatusText" (focus)="isStatusDropdownOpen = true"
                (blur)="closeStatusDropdown()" placeholder="พิมพ์ค้นหา..."
                class="w-full bg-transparent border-none text-xs font-bold text-slate-650 dark:text-slate-300 focus:ring-0 p-0 outline-none">
              <span class="material-icons text-slate-400 text-sm">expand_more</span>
            </div>

            <div *ngIf="isStatusDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute top-full mt-1.5 left-0 w-full bg-white dark:bg-slate-800 border border-slate-100/60 dark:border-slate-750 shadow-xl rounded-xl py-1 z-50 max-h-48 overflow-y-auto custom-scrollbar">
              <button (click)="selectStatus('')"
                class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-500 hover:bg-slate-50 block hover:text-amber-500 transition-colors cursor-pointer">ทั้งหมด</button>
              <button *ngFor="let opt of filteredStatusOptions" (click)="selectStatus(opt)"
                class="w-full text-left px-3.5 py-2 text-xs font-bold text-slate-650 dark:text-slate-300 hover:bg-slate-50 block hover:text-amber-500 transition-colors cursor-pointer">
                {{ opt }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Table scrollable section -->
    <div class="overflow-x-auto h-[550px] relative custom-scrollbar">
      <table class="w-full text-left border-collapse min-w-[1000px]">
        <thead
          class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm dark:shadow-slate-900/40">
          <tr class="border-b border-slate-100 dark:border-slate-700">
            <!-- Sortable headers -->
            <th (click)="sortData('id')"
              class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group">
              <div class="flex items-center gap-1">
                ID
                <span class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                  [class.opacity-100]="sortColumn === 'id'">
                  {{ sortColumn === 'id' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th (click)="sortData('receiptId')"
              class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group">
              <div class="flex items-center gap-1">
                เลขใบเสร็จ
                <span class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                  [class.opacity-100]="sortColumn === 'receiptId'">
                  {{ sortColumn === 'receiptId' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th (click)="sortData('paidDate')"
              class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group">
              <div class="flex items-center gap-1">
                วันที่ชำระ
                <span class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                  [class.opacity-100]="sortColumn === 'paidDate'">
                  {{ sortColumn === 'paidDate' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">บริการ / Fee
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">ช่องทางการชำระ
            </th>
            <th (click)="sortData('total')"
              class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group text-right">
              <div class="flex items-center justify-end gap-1">
                ยอดสุทธิ
                <span class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-550"
                  [class.opacity-100]="sortColumn === 'total'">
                  {{ sortColumn === 'total' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </span>
              </div>
            </th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center">
              สถานะ</th>
            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center">
              ดำเนินการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-750">
          <tr *ngFor="let record of records; let idx = index"
            class="hover:bg-amber-50/20 dark:hover:bg-slate-700/30 transition-colors duration-150">
            <td class="p-5 text-xs font-bold text-slate-400">#{{ record.id }}</td>
            <td class="p-5 text-sm font-bold text-slate-800 dark:text-slate-100">{{ record.receiptId }}</td>
            <td class="p-5 text-xs font-bold text-slate-500 dark:text-slate-400">{{ formatDateDisplay(record.paidDate)
              }}</td>
            <td class="p-5">
              <div class="flex flex-col">
                <span class="text-xs font-bold text-slate-750 dark:text-slate-200">{{ record.feeName }}</span>
                <span class="text-[10px] text-slate-400">Site: {{ record.siteName }}</span>
              </div>
            </td>
            <td class="p-5 text-xs font-bold text-slate-600 dark:text-slate-400">{{ record.feeTypeName }}</td>
            <td class="p-5 text-right">
              <div class="flex flex-col items-end">
                <span class="text-xs font-bold text-slate-800 dark:text-slate-100">{{ record.total | number:'1.2-2' }}
                  ฿</span>
                <span class="text-[9px] text-slate-400">ค่าธรรมเนียม: {{ record.fee | number:'1.2-2' }} / VAT: {{
                  record.vat | number:'1.2-2' }}</span>
              </div>
            </td>
            <td class="p-5 text-center">
              <span class="px-3 py-1 rounded-full text-[10px] font-black tracking-wide"
                [ngClass]="record.status === 'ยกเลิก' || record.statusId === '2'
                  ? 'bg-rose-50 dark:bg-rose-950/20 text-rose-500 border border-rose-100 dark:border-rose-900/30'
                  : (record.status === 'รออนุมัติยกเลิก' || record.pendingApprovalRequestId
                    ? 'bg-amber-50 dark:bg-amber-950/20 text-amber-600 dark:text-amber-400 border border-amber-100 dark:border-amber-900/30'
                    : 'bg-green-50 dark:bg-green-950/20 text-green-600 dark:text-green-400 border border-green-100 dark:border-green-900/30')">
                {{ record.status }}
              </span>
            </td>
            <td class="p-5 text-center">
              <div class="flex items-center justify-center gap-1.5">
                <!-- View Details Eye Button -->
                <button (click)="onViewDetail(record)"
                  class="p-1 flex items-center justify-center rounded-lg text-slate-500 hover:text-amber-500 dark:text-slate-400 dark:hover:text-amber-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all border border-slate-200 dark:border-slate-700 shadow-sm cursor-pointer bg-white dark:bg-slate-800"
                  title="ดูรายละเอียด">
                  <span class="material-icons text-sm block">visibility</span>
                </button>

                <!-- Cancel Action Button (only shows when edit permission is allowed AND canCancel is true AND date matches today) -->
                <button
                  *ngIf="hasEditPermission && record.canCancel && !record.pendingApprovalRequestId && isToday(record.paidDate)"
                  (click)="onCancelClick(record)"
                  class="px-2.5 py-2 rounded-lg text-rose-500 hover:text-white hover:bg-rose-500 transition-all text-xs font-bold border border-rose-200 dark:border-rose-900 hover:border-transparent cursor-pointer shadow-sm bg-white dark:bg-slate-800"
                  title="ขอยกเลิกรายการ">
                  ยกเลิก
                </button>

                <!-- Pending indicator overlay -->
                <span *ngIf="record.pendingApprovalRequestId"
                  class="text-[10px] font-bold text-amber-500 flex items-center justify-center gap-1 whitespace-nowrap">
                  <span class="material-icons text-sm">schedule</span> รออนุมัติ
                </span>
              </div>
            </td>
          </tr>

          <!-- Empty rows fallback layout -->
          <tr *ngIf="records.length === 0 && !isLoading()">
            <td colspan="8" class="py-24 text-center">
              <div class="flex flex-col items-center justify-center">
                <div
                  class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3 shadow-inner">
                  <span class="material-icons text-3xl text-slate-300 dark:text-slate-600">receipt</span>
                </div>
                <h4 class="text-slate-800 dark:text-slate-300 font-extrabold text-sm">ไม่มีข้อมูลรายการรับชำระ</h4>
                <p class="text-xs text-slate-400 mt-1">ลองเปลี่ยนเงื่อนไขการค้นหาหรือช่วงเวลาตัวกรอง</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Standard Pagination Footer -->
    <div
      class="p-6 border-t border-slate-100 dark:border-slate-750 bg-white dark:bg-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
      <!-- Left: Item Range Info & Page Size Selection -->
      <div class="flex items-center gap-3">
        <span class="text-xs font-semibold text-slate-550">
          แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems | number }} รายการ
        </span>

        <!-- Page Size Selection Dropdown -->
        <div class="relative">
          <button (click)="togglePageSizeDropdown()" (blur)="closePageSizeDropdown()"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-850 border border-slate-200/80 dark:border-slate-700 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 focus:outline-none focus:ring-1 focus:ring-amber-450 cursor-pointer transition-all shadow-sm">
            <span>{{ pageSize }} / หน้า</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isPageSizeDropdownOpen">expand_more</span>
          </button>

          <div *ngIf="isPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute bottom-full left-0 mb-1.5 z-50 min-w-[5.5rem] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-scale-up text-center">
            <button *ngFor="let opt of pageSizeOptions" (click)="selectPageSize(opt)"
              class="w-full text-center px-3.5 py-2 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 hover:text-amber-500 block transition-colors cursor-pointer">
              {{ opt }} / หน้า
            </button>
          </div>
        </div>
      </div>

      <!-- Right: Pagination Buttons -->
      <div class="flex items-center gap-1">
        <!-- Prev Page -->
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-8 h-8 rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-850 text-slate-500 disabled:opacity-40 hover:bg-slate-50 hover:text-amber-500 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>

        <!-- Numbered Pages -->
        <ng-container *ngFor="let page of pagesArray">
          <!-- Active Page -->
          <button *ngIf="page === currentPage"
            class="w-8 h-8 rounded-lg bg-amber-400 text-slate-900 font-bold shadow-[0_4px_12px_rgba(251,191,36,0.35)] flex items-center justify-center text-xs">
            {{ page }}
          </button>

          <!-- Inactive Page -->
          <button *ngIf="page !== currentPage" (click)="setPage(page)"
            class="w-8 h-8 rounded-lg text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-50 hover:text-amber-500 transition-colors flex items-center justify-center text-xs cursor-pointer">
            {{ page }}
          </button>
        </ng-container>

        <!-- Next Page -->
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="w-8 h-8 rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-850 text-slate-500 disabled:opacity-40 hover:bg-slate-50 hover:text-amber-500 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Detail view modal component -->
<app-modal-parking-fine-detail *ngIf="isDetailModalOpen" [record]="selectedRecordDetail"
  [hasEditPermission]="hasEditPermission" [hasUpdatePermission]="hasUpdatePermission"
  [hasDeletePermission]="hasDeletePermission" [siteId]="selectedSiteId" [userId]="userId"
  (close)="closeDetailModal()"
  (viewReceipt)="onViewReceiptFromDetailComponent($event)" (cancelRequest)="onCancelFromDetailComponent($event)">
</app-modal-parking-fine-detail>

<!-- Receipt view modal component -->
<app-modal-parking-fine-receipt *ngIf="isReceiptModalOpen" [record]="selectedRecordReceipt"
  [siteId]="selectedSiteId" [userId]="userId" [menuId]="menuId"
  [canIssueFullTax]="canIssueFullTaxInvoice(selectedRecordReceipt)"
  (close)="closeReceiptModal()"
  (issued)="onIssueFullTaxFromReceipt($event)">
</app-modal-parking-fine-receipt>

<!-- Cancellation confirmation overlay modal (standardized) -->
<app-pss-confirm-modal *ngIf="isCancelModalOpen" title="ยืนยันการยกเลิกรายการรับชำระ?"
  message="คุณกำลังขออนุมัติยกเลิกใบเสร็จรับเงินเลขที่" [highlight]="selectedRecordForCancel?.receiptId || ''"
  messageSuffix="โปรดตรวจสอบข้อมูลให้ครบถ้วนก่อนยืนยัน" confirmLabel="ขอยกเลิกรายการ" cancelLabel="กลับไปแก้ไข"
  variant="danger" icon="cancel" (confirm)="onConfirmCancel()" (cancel)="closeCancelModal()">
</app-pss-confirm-modal>

<!-- CRITICAL: Full-screen loading overlay placed OUTSIDE the main container -->
<app-pss-loading *ngIf="isLoading() || isDashboardLoading() || isCancelling()"
  [text]="isCancelling() ? 'กำลังส่งข้อมูลขอยกเลิก...' : 'กำลังดึงข้อมูล...'" detail="โปรดรอสักครู่ . . .">
</app-pss-loading>